import React from 'react';
import { Navbar, Nav, Container, Row, Col, Button, Image } from 'react-bootstrap';
import CeroLogo from '../assets/CeroBrandLogo.svg';
import ArrowUp from '../assets/arrowUp.svg';
import MenuIcon from '../assets/menuIcon.svg';

const CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/cero-linkedin-personal-br/moeocagahkkomhnekdhlfjbmomkjoddj?hl=en';

export const HeaderNav: React.FC = () => {
  return (
    <>
      <style>{`
        .header-nav__navbar {
          height: clamp(72px, 9dvh, 92px);
        }

        .header-nav__navbar > .container-fluid {
          height: 100%;
          align-items: center;
        }

        .header-nav__brand img {
          height: clamp(24px, 3.2dvh, 30px);
          width: auto;
        }

        .header-nav__collapse {
          align-items: center;
        }

        .header-nav__toggle {
          border: none;
          box-shadow: none;
        }

        .header-nav__toggle .navbar-toggler-icon {
          display: none;
        }

        .header-nav__cta.btn {
          height: auto;
          min-height: 0;
          align-self: center;
          flex-shrink: 0;
          gap: 10px;
          border-radius: 14px;
          border-width: 1.5px;
          border-style: solid;
          border-color: rgba(255, 255, 255, 0.16);
          padding: 13px 18px 13px 28px;
          background: #ff8000;
          box-shadow: inset 0px 0px 6px 0px rgba(255, 255, 255, 0.16);
          color: #030303;
          font-size: clamp(13px, 0.9vw, 16px);
          font-weight: 500;
          line-height: 1.2;
          white-space: nowrap;
        }

        .header-nav__cta.btn:hover,
        .header-nav__cta.btn:focus-visible {
          color: #030303;
          background: #ff8000;
          border-color: rgba(255, 255, 255, 0.16);
          box-shadow: inset 0px 0px 6px 0px rgba(255, 255, 255, 0.16);
        }

        .header-nav__cta img {
          height: 18px;
          width: auto;
          flex-shrink: 0;
        }

        @media (max-width: 991.98px) {
          .header-nav__navbar {
            background: transparent !important;
            border: none !important;
            backdrop-filter: none !important;
            height: auto !important;
            min-height: clamp(48px, 8dvh, 56px);
            padding-left: clamp(16px, 4vw, 28px) !important;
            padding-right: clamp(16px, 4vw, 24px) !important;
          }

          .header-nav__brand .vr {
            display: none !important;
          }

          .header-nav__brand img {
            height: clamp(28px, 8vw, 32px) !important;
          }

          .header-nav__toggle {
            width: clamp(48px, 13vw, 56px);
            height: clamp(48px, 13vw, 56px);
            border-radius: 12px !important;
            border: 1px solid rgba(255, 255, 255, 0.06) !important;
            background: rgba(255, 255, 255, 0.06) !important;
            backdrop-filter: none;
            box-shadow: inset 0px 0px 14px 0px rgba(255, 255, 255, 0.04);
            padding: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .header-nav__collapse {
            margin-top: 16px;
            padding: 16px;
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.06);
            background: rgba(255, 255, 255, 0.06);
            backdrop-filter: none;
          }

          .header-nav__collapse .nav {
            gap: 8px !important;
          }

          .header-nav__cta-wrap {
            width: 100%;
            margin-top: 12px;
          }

          .header-nav__cta {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>

      <Container
        fluid
        className="d-flex justify-content-center header-nav"
        style={{ paddingTop: 20, marginBottom: 60 }}
      >
        <Row className="w-100 justify-content-center">
          <Col className="d-flex justify-content-center" style={{ width: '95%' }}>
            <Navbar
              expand="lg"
              className="px-4 w-100 header-nav__navbar"
              style={{
                borderRadius: 20,
                border: '1px solid #FFFFFF0F',
                background: '#FFFFFF0F',
                backdropFilter: 'blur(6px)',
              }}
            >
              <Container fluid className="align-items-center p-0">
                <Navbar.Brand
                  href="#"
                  className="d-flex align-items-center gap-3 m-0 header-nav__brand"
                >
                  <Image src={CeroLogo} alt="Cero" />
                  <div
                    className="vr"
                    style={{ opacity: 0.15, color: '#FFFFFF', marginRight: 10 }}
                  />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="main-nav" className="header-nav__toggle">
                  <Image src={MenuIcon} alt="Open menu" height={28} />
                </Navbar.Toggle>

                <Navbar.Collapse id="main-nav" className="header-nav__collapse">
                  <Nav className="me-auto gap-4">
                    <Nav.Link href="#features" className="text-white">
                      Features
                    </Nav.Link>
                    <Nav.Link href="#reviews" className="text-white">
                      Reviews
                    </Nav.Link>
                    <Nav.Link href="#pricing" className="text-white">
                      Pricing
                    </Nav.Link>
                    <Nav.Link href="#community" className="text-white">
                      Join Community
                    </Nav.Link>
                  </Nav>
                  <div className="ms-lg-auto d-flex align-items-center gap-3 header-nav__cta-wrap">
                    <Button
                      as="a"
                      href={CHROME_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="link"
                      className="d-flex align-items-center justify-content-center text-decoration-none header-nav__cta"
                    >
                      <span>Claim Your Free Trial</span>
                      <Image src={ArrowUp} alt="Free Trial" />
                    </Button>
                  </div>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </Col>
        </Row>
      </Container>
    </>
  );
};
